"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const pulse_components_1 = require("@pcs/pulse-components");
const react_redux_1 = require("react-redux");
const material_1 = require("@mui/material");
const styles_modules_less_1 = __importDefault(require("./styles.modules.less"));
const store_1 = require("../../../store");
const sliceTemplate_1 = require("../../../slice/sliceTemplate");
const constants_1 = require("../../../slice/sliceTemplate/constants");
const sliceReview_1 = require("../../../slice/sliceReview");
const DATA_STRUCTURE = {
    dataKey: 'data',
    isJsonApi: true,
    label: 'label',
    lastPage: 'meta.page.last_page',
    pageSize: 25,
    type: 'workflowTemplates',
    value: 'id',
    searchKey: 'name',
};
const ExpandedPermissionSelects = react_1.default.lazy(() => Promise.resolve().then(() => __importStar(require('../TemplateSettingModal/PermissionSelects'))));
const DEFAULT_URL = `/v2/api/workflow-templates`;
const SearchUpdateTemplate = () => {
    const dispatch = (0, store_1.useDocumentReviewDispatch)();
    const { selectedTemplate } = (0, react_redux_1.useSelector)((state) => state.template);
    (0, react_1.useEffect)(() => {
        dispatch((0, sliceTemplate_1.updateSavingMethod)(constants_1.SAVING_METHOD.updateExisting));
    }, []);
    (0, react_1.useEffect)(() => {
        if (selectedTemplate) {
            dispatch((0, sliceTemplate_1.updateTemplateName)(selectedTemplate.label));
            dispatch((0, sliceReview_1.enableNextBtn)());
        }
        else {
            dispatch((0, sliceReview_1.disableNextBtn)());
        }
    }, [selectedTemplate]);
    const handleChangeTemplate = (template) => {
        const selectTemplate = template;
        dispatch((0, sliceTemplate_1.setSelectedTemplate)({
            value: `${selectTemplate.value}`,
            label: selectTemplate.label,
        }));
        dispatch((0, sliceTemplate_1.getPermissionTemplate)(`${selectTemplate.value}`));
    };
    return (react_1.default.createElement("section", { className: styles_modules_less_1.default['search-template__root'] },
        react_1.default.createElement("div", { className: styles_modules_less_1.default['search-template__warning'] },
            react_1.default.createElement("div", { className: styles_modules_less_1.default['warning-icon'] },
                react_1.default.createElement("i", { className: "fal fa-info-circle" })),
            react_1.default.createElement("p", { className: styles_modules_less_1.default['warning-message'] }, "If you update an existing Round Template, the changes to the Stages and Settings will only affect future applications of the Template. Reviews using the previous version of the Template will not be affected.")),
        react_1.default.createElement("div", { className: styles_modules_less_1.default['select-template__root'] },
            react_1.default.createElement(pulse_components_1.PulseSelectBase, { selectOnlyOption: true, classes: {
                    label: styles_modules_less_1.default['select-template__label'],
                }, value: selectedTemplate, dataStructure: DATA_STRUCTURE, url: DEFAULT_URL, isDisabled: false, isClearable: false, hideMenuOnValueChange: true, isSearchable: true, labelName: "Search for existing Template", insideModal: true, placeholder: "Search for a template to update\u2026", onChange: handleChangeTemplate, labelIcon: {
                    icon: 'fal fa-info-circle',
                    tippyDescription: 'Select a template from the dropdown list to update the template with the new stage and settings information',
                    TippyProps: {
                        placement: 'top',
                        popperOptions: {
                            strategy: 'fixed',
                        },
                    },
                } })),
        react_1.default.createElement(react_1.default.Suspense, { fallback: react_1.default.createElement("div", null, "Loading...") }, selectedTemplate && (react_1.default.createElement("div", null,
            react_1.default.createElement(material_1.Divider, null),
            react_1.default.createElement(ExpandedPermissionSelects, null))))));
};
exports.default = SearchUpdateTemplate;
